import process from "process";
import { PixelCrop } from 'react-image-crop'
import { IUserDto } from "./entities/IUserDto";
import { IAdditionalField } from "./entities/RegisterEvent/ILevel";
import AppConst from "./entities/AppConsts";

const development: boolean =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export function isDev(): boolean {
  return development || window.location.host.includes('x-inf-dev');
}

/** 開發模式才會出現的Console.log */
export function DevLog(...args) {
  if (!isDev()) {
    return;
  }
  return console.trace(...args);
}

export function CreateUUID() {

  try {
    // 如果瀏覽器有原生方法, 就使用原生
    if (crypto) {
      return crypto.randomUUID()
    }
  }
  catch {

  }
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
  });
  return uuid;
}
export async function CanvasPreview(
  image: HTMLImageElement,
  canvas: HTMLCanvasElement,
  crop: PixelCrop,
  scale = 1,
  rotate = 0,
) {
  const ctx = canvas.getContext('2d')

  if (!ctx) {
    throw new Error('No 2d context')
  }

  const scaleX = image.naturalWidth / image.width
  const scaleY = image.naturalHeight / image.height

  ctx.imageSmoothingQuality = 'high'

  const cropX = crop.x * scaleX
  const cropY = crop.y * scaleY

  ctx.save()

  ctx.drawImage(
    image,
    cropX,
    cropY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    canvas.width,
    canvas.height,
  )

  console.log(image.naturalWidth, image.naturalHeight, image.width, image.height)
  console.log(cropX, cropY, crop.width * scaleX, crop.height * scaleY, canvas.width, canvas.height)

  ctx.restore()
}

export function isUserManager(user: IUserDto) {

  if (!user) {
    return false;
  }
  return user.userPermissions.includes("management");
}

export function isUserSuperAdmin(user: IUserDto) {

  if (!user) {
    return false;
  }
  return user.userPermissions.includes(`volunteer`) ||
    user.userPermissions.includes("management.superadmin")
}

export function isUserVolunteer(user: IUserDto) {

  if (!user) {
    return false;
  }
  return user.userPermissions.includes(`volunteer`) ||
    user.userPermissions.includes("management.superadmin")
}
/** 
 * 2024新增：額外付費項目的計算 
 * @param fields 該等級的額外加購項目
 * @param registrationAdditionalInfo 目前表單額外加購項目的formValues
 * @param orgAdditionalInfo 原先有的值，用來加購比較用
 * */
export function GetAdditionlProducts(fields: IAdditionalField[], registrationAdditionalInfo: {}, orgAdditionalInfo?: {}) {

  function getKey(f: IAdditionalField, v: any) {
    if (f.type === 'enum') {
      return `events.${AppConst.eventKey}.enum.${f.key}.${v}`
    }
    return f.key
  }

  // 無額外欄位跳過計算
  if (!fields?.length) {
    return [];
  }

  return fields.map(f => {
    // 如果 type == number
    // 他會是用乘ㄉ addonPrice * 使用者輸入的數值
    const v = registrationAdditionalInfo?.[f.key]
    const orgV = orgAdditionalInfo?.[f.key]

    if (f.type === 'number') {
      // 取得該欄位使用者輸入的數值 (?)
      return [{
        key: f.key,
        addonPrice: ((v - (orgV || 0)) || 0) * (f.addonPrice || 0)
      }]
    }
    if (f.type === 'enum') {
      const e = f.enum.find(e => e.value === v)
      const orgE = f.enum.find(e => e.value === orgV)
      if (orgE && e) {
        return [
          {
            key: getKey(f, e.value), addonPrice: e.addonPrice - orgE.addonPrice
          }
        ]
      }
      return e ? [
        { key: getKey(f, e.value), addonPrice: e.addonPrice }
      ] : []
    }
    // 多選的場合
    // 如果是 enum 就把所選 addonPrice ㄉ加總
    if (f.type === 'array' && f.arrayType === 'enum') {
      return f.enum.filter(e => (e.addonPrice || 0) * (
        // 若有選取的場合, 算入價格
        (v as Array<string> || [])?.includes(e.value) ? 1 : 0)
      ).map(e => ({
        key: getKey(f, e.value),
        addonPrice: e.addonPrice - ((orgV as Array<string>)?.includes(e.value) ? e.addonPrice : 0)
      }))
    }
    return []
  }).flat()
}

/** 送出時修正type=array內的數值 */
// formValues需帶有registrationAdditionalInfo子屬性
export function FixFormValuesAdditionalFields(formValues: any, fields: IAdditionalField[]) {
  const newValues = { ...formValues }
  fields?.forEach(e => {
    if (e.type !== 'array') {
      return;
    }
    newValues.registrationAdditionalInfo[e.key] =
      (newValues.registrationAdditionalInfo[e.key] as Array<any> || [])
        .filter(v => Boolean(v))
  })

  return newValues
}